<template>
  <div
    style="flex: 0 0 25%; max-width: 30%"
    class="card-view-detailing px-4 py-6 bg-white rounded shadow-md
      lg:max-w-[30%] lg:flex-none
      md:max-w-[50%] md:flex-none
      sm:max-w-full sm:w-full sm:px-2 sm:py-4
      w-full"
  >
    <form @submit.prevent="handleSearch" class="flex flex-col space-y-4">
      <!-- Search Hotel Name -->
      <div>
        <label for="searchHotelName" class="text-sm font-medium text-stone-900">Search Hotel</label>
        <input type="text" v-model="searchHotelName" id="searchHotelName"
          class="w-full mt-2 rounded border border-stone-400 p-2 text-sm" />
      </div>

      <!-- Check-in and Check-out Dates -->
      <div class="flex gap-4 flex-col sm:flex-row">
        <div class="w-full sm:w-1/2">
          <label for="checkInDate" class="text-sm font-medium text-stone-900"
            >Check In</label
          >
          <input
            type="text"
            v-model="checkin"
            id="checkInDate"
            class="w-full mt-2 rounded border border-stone-400 p-2 text-sm"
          />
        </div>
        <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
          <label for="checkOutDate" class="text-sm font-medium text-stone-900"
            >Check Out</label
          >
          <input
            type="text"
            v-model="checkout"
            id="checkOutDate"
            class="w-full mt-2 rounded border border-stone-400 p-2 text-sm"
          />
        </div>
      </div>

      <!-- Sort By -->
      <div>
        <label for="sort_by" class="text-sm font-medium text-stone-900">Sort By</label>
        <select v-model="sortBy" id="sort_by" class="w-full mt-2 rounded border border-stone-400 p-2 text-sm">
          <option value="name">A-Z</option>
          <option value="price_desc">Price High to Low</option>
          <option value="price_asc">Price Low to High</option>
        </select>
      </div>

      <!-- Rooms -->
      <!-- <div>
        <div v-for="(room, index) in rooms" :key="index" class="mb-4">
          <div class="flex justify-between items-center">
            <h4 class="text-sm font-medium text-stone-900">
              Room {{ index + 1 }}
            </h4>
            <button
              v-if="index > 0"
              @click.prevent="removeRoom(index)"
              class="bg-red-600 text-white px-2 py-1 rounded"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="mt-2">
            <label class="text-sm font-medium text-stone-900">Adults</label>
            <input
              type="number"
              v-model.number="room.adults"
              class="w-full mt-1 rounded border border-stone-400 p-2"
              min="1"
              max="6"
            />
          </div>
          <div class="mt-2">
            <label class="text-sm font-medium text-stone-900">Children</label>
            <input
              type="number"
              v-model.number="room.children"
              class="w-full mt-1 rounded border border-stone-400 p-2"
              min="0"
              max="4"
            />
          </div>
          <div
            v-if="room.children > 0 && room.ages"
            class="grid grid-cols-2 gap-4 mt-2"
          >
            <div v-for="childIndex in room.children" :key="childIndex">
              <label class="text-sm text-stone-500">
                Child {{ childIndex }} Age
              </label>
              <input
                type="number"
                v-model.number="room.ages[childIndex - 1]"
                class="w-full mt-1 rounded border border-stone-400 p-2"
                min="0"
                max="17"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <button
            @click.prevent="addRoom"
            class="add-room bg-stone-900 text-white px-4 py-2 rounded flex items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="h-5 w-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
            <span>Add another room</span>
          </button>
        </div>
      </div> -->

      <div class="mt-2">
        <label class="text-sm font-medium text-stone-900">Filter by Property Type</label>
        <MultiSelect v-model="selectedProperty" :options="propertyList" label="Property Type" />
      </div>
      <div class="mt-2">
        <label class="text-sm font-medium text-stone-900">Filter by Amenities</label>
        <MultiSelect v-model="selectedAmenities" :options="amenitiesList" label="Amenities" />
      </div>
      <div class="mt-2">
        <label class="text-sm font-medium text-stone-900">Filter by Location</label>
        <MultiSelect v-model="selectedLocation" :options="locationList" label="Locations" />
      </div>
      <!-- Filter by Price (Multi-Range Slider) -->
      <!-- <div class="mb-4">
        <label class="text-sm font-medium text-stone-900"
          >Filter by Price</label
        >
        <div class="mt-2 MultiRangeSliderContainer">
          <MultiRangeSlider
            baseClassName="multi-range-slider-bar-only"
            :min="'0'"
            :max="searchStore?.getPriceRange?.max"
            :ruler="true"
            :label="true"
            :minValue="searchStore?.getPriceRange?.min"
            :maxValue="searchStore?.getPriceRange?.max"
            @input="UpdateValues"
          />
        </div>
      </div> -->

      <!-- Submit Button -->
      <button
        type="submit"
        class="lsp-btn mt-3 px-3 py-2 rounded font-medium text-center w-full text-base">
        Search
      </button>
    </form>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import MultiRangeSlider from "multi-range-slider-vue";
import "../../../../node_modules/multi-range-slider-vue/MultiRangeSliderBlack.css";
import "../../../../node_modules/multi-range-slider-vue/MultiRangeSliderBarOnly.css";
import MultiSelect from "../../src/UI/multiSelect.vue";
import { useSearchStore } from "../../stores/search.module";
import { formatDate } from "../../utils/imageFunction.js";


// Reactive state
const searchHotelName = ref("");
const searchStore = useSearchStore();
const checkin = ref();
const checkout = ref();
const today = new Date();
const sortBy = ref("name");
const barMinValue = ref();
const barMaxValue = ref();
const rooms = ref([{ adults: 2, children: 0, ages: [] }]);
const selectedAmenities = ref([]);
const selectedLocation = ref([]);
const selectedProperty = ref([]);

// Computed properties
const budgets = computed(() => ["0", "3330", "6660", "9990", "13320", "18517"]);
const amenitiesList = computed(() =>
  searchStore.amenities.map((amenity) => ({
    id: amenity.id,
    name: amenity.category_name,
  }))
);
const locationList = computed(() =>
  searchStore.availableLocations.map((location) => ({
    id: location.id,
    name: location.category_name,
  }))
);
const propertyList = computed(() =>
  searchStore.typeOfProperty.map((property) => ({
    id: property.id,
    name: property.category_name,
  }))
);

const setDefaultDates = () => {
  const checkinDate = new Date(today);
  checkinDate.setDate(today.getDate() + 14);

  const checkoutDate = new Date(today);
  checkoutDate.setDate(today.getDate() + 16);

  checkin.value = checkinDate;
  checkout.value = checkoutDate;
};

const isDateInput = computed(() => false);

const initializeDatePickers = () => {
  const checkInPicker = flatpickr("#checkInDate", {
    altInput: true,
    altFormat: "j F, Y",
    dateFormat: "Y-m-d",
    defaultDate: checkin.value,
    minDate: "today",
    onChange: (selectedDates) => {
      checkin.value = selectedDates[0];
      // Store checkin date in localStorage
      localStorage.setItem("selectedCheckin", formatDate(selectedDates[0]));

      // Auto-update checkout date if it's earlier than check-in
      if (checkout.value < checkin.value) {
        const newCheckoutDate = new Date(checkin.value);
        newCheckoutDate.setDate(checkin.value.getDate() + 2);
        checkout.value = newCheckoutDate;
        // Store updated checkout date
        localStorage.setItem("selectedCheckout", formatDate(newCheckoutDate));
      }
    },
  });

  const checkOutPicker = flatpickr("#checkOutDate", {
    altInput: true,
    altFormat: "j F, Y",
    dateFormat: "Y-m-d",
    defaultDate: checkout.value,
    minDate: "today",
    onChange: (selectedDates) => {
      checkout.value = selectedDates[0];
      // Store checkout date in localStorage
      localStorage.setItem("selectedCheckout", formatDate(selectedDates[0]));

      // Prevent checkout from being before check-in
      if (checkout.value < checkin.value) {
        alert("Checkout date cannot be before check-in date.");
        checkout.value = new Date(checkin.value);
        checkout.value.setDate(checkin.value.getDate() + 2);
        // Store updated checkout date
        localStorage.setItem("selectedCheckout", formatDate(checkout.value));
      }
    },
  });

  // Add scroll event listener to close pickers
  const handleScroll = () => {
    checkInPicker.close();
    checkOutPicker.close();
  };

  window.addEventListener('scroll', handleScroll);

  // Return the cleanup function
  return () => {
    window.removeEventListener('scroll', handleScroll);
    checkInPicker.destroy();
    checkOutPicker.destroy();
  };
};

const UpdateValues = (e) => {
  barMinValue.value = e.minValue;
  barMaxValue.value = e.maxValue;
};

const addRoom = () => {
  rooms.value.push({ adults: 2, children: 0, ages: [] });
};

const removeRoom = (index) => {
  rooms.value.splice(index, 1);
};

const handleSearch = () => {

  // Safely map over rooms
  const formattedOccupancy = (Array.isArray(rooms.value) ? rooms.value : []).map((room) => {
    const adultsCount = room.adults;
    const childrenAges = room.ages && room.ages.length > 0 ? room.ages.join(",") : "";
    return `${adultsCount}-${childrenAges}`;
  }).join(",");
  searchStore.setRooms(formattedOccupancy);
  const searchedData = {
    searchHotelName: searchHotelName.value,
    // search: true,
    checkin: formatDate(checkin.value),
    checkout: formatDate(checkout.value),
    sort_by: sortBy.value,
    // from: barMinValue.value || searchStore?.getPriceRange?.min,
    // to: barMaxValue.value || searchStore?.getPriceRange?.min,
    // per_page: 15,
    amenities: selectedAmenities.value.map((item) => item.id),
    locations: selectedLocation.value.map((item) => item.id),
    propertyType: selectedProperty.value.map((item) => item.id),
    // rooms: rooms.value,
  };
  searchStore.setSearchParams(searchedData);
  searchStore.search(searchedData);
  searchStore.setCheckout(checkout);
  searchStore.setCheckin(checkin);
  searchStore.setSearch(true)
};

// Lifecycle hooks
onMounted(() => {
  setDefaultDates();
  const cleanup = initializeDatePickers();

  // Return cleanup function to be called on unmount
  return cleanup;
});
</script>

<style scoped>
@media (max-width: 1024px) {
  .card-view-detailing {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
@media (max-width: 640px) {
  .card-view-detailing {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  }
}
.MultiRangeSliderContainer {
  margin: auto;
  width: 100%;
}
</style>
